<template>
    <v-col
        cols="12"
        md="3"
        :class="`pl-${paddingLeft} pr-${paddingRight} pb-${isMobilePort ? 3 : ''}`">
        <template v-if="isMobilePort">
            <v-menu offset-y close-on-content-click v-if="menuGroups.length > 1">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        block
                        depressed
                        x-large
                        color="primary"
                        height="52"
                        v-bind="attrs"
                        v-on="on"
                        aria-haspopup="true"
                        :aria-expanded="menuIsActive.toString()"
                        :class="btnClassName">  <!-- Don't change/remove, using for Google analytics tracking -->
                        {{ title }}
                        <v-icon right>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-card style="min-width: 400px">
                    <v-row dense>
                        <v-col>
                            <v-list dense role="menu">
                                <v-list-item v-for="(group, i) in menuGroups" :key="i" role="menuitem"
                                    :href="getCategoryUrlFromSlug(group.slug)">
                                    <v-list-item-content>{{ group.title }}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card>
            </v-menu>
            <v-btn v-else block depressed x-large color="primary" height="52"
                :href="getCategoryUrlFromSlug(menuGroups[0]['slug'])">
                {{ title }}
            </v-btn>
        </template>
        <template v-else>
            <v-menu offset-y close-on-content-click>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        block
                        depressed
                        x-large
                        color="primary"
                        height="52"
                        v-bind="attrs"
                        v-on="on"
                        aria-haspopup="true"
                        :aria-expanded="menuIsActive.toString()"
                        :class="btnClassName"> <!-- Don't change/remove, using for Google analytics tracking -->
                        {{ title }}
                        <v-icon right>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-card style="min-width: 400px">
                    <v-row dense>
                        <v-col :key="i" v-for="(group, i) in menuGroups">
                            <h5 class="list-subtitle font-weight-bold pa-4">{{ group.title }}</h5>
                            <v-divider />
                            <v-list dense :style="calculateColumnCountStyle(group.items?.length || 0)" role="menu">
                                <v-list-item v-for="item in group.items" :key="item.key" role="menuitem"
                                    :href="getCategoryUrlFromSlug(item.slug)">
                                    <v-list-item-content>{{ item.name }}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card>
            </v-menu>
        </template>

    </v-col>
</template>

<script>
import Mobile from '../inc/mixins/mobile';
export default {
    data() {
        return {
            menuIsActive: false
        }
    },
    props: {
        title: String,
        btnClassName: String,
        menuGroups: Array,
        paddingLeft: Number,
        paddingRight: Number
    },
    mixins: [Mobile],
    methods: {
        calculateColumnCountStyle(length) {
            const columnCount = Math.ceil(length / 10);
            return {
                columnCount: columnCount,
                columnGap: '0px'
            };
        },
        getCategoryUrlFromSlug(slug) {
            return this.getRoute("codes_category", { category: slug });
        }
    }
};
</script>
